export default {"src":"/_next/static/media/@youtube.e2a79f1d.svg","height":30,"width":30};